<template>
  <!-- Main Content -->
  <div class="page-wrapper">
    <div class="container-fluid">

      <!-- Title -->
      <div class="row heading-bg">
        <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
          <h5 class="txt-dark">
            PT Configuration
            <add-button link="/settings/pt-configurations/create"></add-button>
          </h5>
        </div>
        <!-- Breadcrumb -->
        <div class="col-lg-9 col-sm-8 col-md-8 col-xs-12">
          <ol class="breadcrumb">
            <li><router-link to="/">Dashboard</router-link></li>
            <li>Data Center</li>
            <li class="active">PT Configuration</li>
          </ol>
        </div>
        <!-- /Breadcrumb -->
      </div>
      <!-- /Title -->
      
      <!-- Row -->
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="table-wrap">
                  <table class="table table-hover table-striped">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Effective Date</th>
                        <th>State</th>
                        <!-- <th>Employer PT</th> -->
                        <th>Employee PT</th>
                        <th>Min Wage</th>
                        <th>Max Wage</th>
                        <th>Applicable to Men</th>
                        <th>Applicable to Women</th>
                      </tr>
                    </thead>
                    <tbody>
                      <loading-table :isLoading="isLoading" cols="8"></loading-table>
                      <router-link 
                        v-for="(ptConfiguration, at) in pt_configurations"
                        :key="`pfConfiguration${at}`"
                        :to="`/settings/pt-configurations/${ptConfiguration.id}`"
                        tag="tr"
                      >
                        <td>{{ serialNoStarting + at + 1 }}</td>
                        <td>{{ ptConfiguration.effective_date | ddmmyyyy }}</td>
                        <td>{{ ptConfiguration.state ? ptConfiguration.state.code : '' }}</td>
                        <!-- <td>{{ ptConfiguration.employer_value }} {{ ptConfiguration.employer_type == 1 ? 'Flat' : '%' }}</td> -->
                        <td>{{ ptConfiguration.employee_value }} {{ ptConfiguration.employee_type == 1 ? 'Flat' : '%' }}</td>
                        <td>{{ ptConfiguration.min_wage }} </td>
                        <td>{{ ptConfiguration.max_wage }} </td>
                        <td>{{ ptConfiguration.is_men == 1 ? 'YES' : 'NO' }} </td>
                        <td>{{ ptConfiguration.is_women == 1 ? 'YES' : 'NO' }} </td>
                      </router-link>
                    </tbody>
                  </table>
                </div>
                <pagination :count="count" @submit="getData"></pagination>
              </div>
            </div>
          </div>  
        </div>
      </div>
      <!-- /Row -->
    </div>
  </div>
  <!-- /Main Content -->
</template>

<script type="text/javascript">
import axios from 'axios'

export default {
  name: 'ptConfigurations',
  data () {
    return {
      pt_configurations: [],
      masters: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData(page = 1) {
      this.isLoading = true
      let pt_configurations = await axios.get(`/pt_configurations?page=${page}&rowsPerPage=${this.rowsPerPage}&search=all`)
      this.pt_configurations = pt_configurations.data.data
      this.count = pt_configurations.data.count
      this.serialNoStarting = (page - 1) * this.rowsPerPage
      this.isLoading = false
    }
  }
}
</script>